var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 0.993,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aabee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ed9"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 18,
    cy: 18,
    r: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M190.332,307.912q7.8-3.4,10.4-4.481c4.954-2.061,5.984-2.419,6.655-2.43a1.173,1.173,0,0,1,.691.207.751.751,0,0,1,.254.483,3.146,3.146,0,0,1,.03.7c-.268,2.821-1.43,9.666-2.021,12.826-.25,1.337-.742,1.785-1.219,1.829-1.036.1-1.823-.685-2.826-1.342-1.57-1.029-2.457-1.67-3.981-2.674-1.761-1.161-.62-1.8.384-2.841.263-.273,4.827-4.425,4.915-4.8a.364.364,0,0,0-.083-.315.411.411,0,0,0-.369-.036q-.236.054-7.525,4.974a3.387,3.387,0,0,1-1.935.715,12.733,12.733,0,0,1-2.773-.656c-1.117-.363-2.005-.555-1.928-1.172Q189.065,308.416,190.332,307.912Z",
    transform: "translate(-182.257 -290.261)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2c78bfcd2881843f8a9f39197f9ccf26.svg";
export { ForwardRef as ReactComponent };